import { isDevelopmentEnvironment, isStagingEnvironment } from '@alexis/helpers/environment';

declare global {
  interface Window {
    googleMapScriptCallback(): void;
  }
}

const googleMapApiKey: string =
  isDevelopmentEnvironment(window.location.hostname) ||
  isStagingEnvironment(window.location.hostname)
    ? 'AIzaSyBlqZTuXygnG7cUd9REQ8ZiL2SnH4okOXs'
    : 'AIzaSyD6OjFDHgwRaQTlZFHYNJCkT3VNugqNBfU';

const googleMapScriptCallback = new Promise<void>(
  (resolve) => (window.googleMapScriptCallback = () => resolve()),
);

export function injectGoogleMapScript(locale: string): Promise<void> {
  const elementId: string = 'googleMapScript';
  const document$: Document = document;
  const existingScriptElement = document$.getElementById(elementId);

  if (!existingScriptElement) {
    const scriptElement = document$.createElement('script');
    scriptElement.id = elementId;
    scriptElement.async = true;
    scriptElement.defer = true;
    scriptElement.src = `https://maps.googleapis.com/maps/api/js?key=${googleMapApiKey}&callback=googleMapScriptCallback&language=${locale}&libraries=geometry,places`;

    document$.head.appendChild(scriptElement);
  }
  return googleMapScriptCallback;
}
